import { DocumentContext } from '../types'
import { computed, shallowRef } from 'vue'
import {
  documentVersionList,
  documentVersionRollback,
} from '@/requests/document'
import { DocumentVersion } from '@/utils/types/document'
import { handleAsync, setSnackbar } from 'best-modules/plugins'

export function useVersions({ documentId, getDocument }: DocumentContext) {
  const versionList = shallowRef<DocumentVersion[]>([])

  const getVersionList = () => {
    return documentVersionList(documentId.value).then(res => {
      versionList.value = res
    })
  }

  const versionRollback = (versionId: number) => {
    return handleAsync(`versionRollback_${versionId}`, () => {
      return documentVersionRollback(versionId).then(async () => {
        await getDocument()
        await getVersionList()
        setSnackbar({ text: 'Активну версію документа оновлено' })
      })
    })
  }

  const activeVersion = computed<DocumentVersion | null>(() => {
    return versionList.value.find(v => v.isActive) || null
  })

  return {
    versionList,
    getVersionList,
    versionRollback,
    activeVersion,
  }
}
